<template>
  <div class="blm-nocontent-contain">
    <div>
      <div v-show="answer.sectionId">{{ answer.componentName }}</div>
      <span>暂时无法回答此问题</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    answer: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>
